import React, { useEffect, useRef } from "react";

function SplashCursor() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let particles = [];
    let animationId;

    // Configurar canvas
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    // Partícula de acuarela
    class WatercolorParticle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.vx = (Math.random() - 0.5) * 0.8;
        this.vy = (Math.random() - 0.5) * 0.8;
        this.radius = Math.random() * 8 + 3;
        this.maxRadius = this.radius + Math.random() * 12;
        this.opacity = 0.3;
        this.life = 1;
        this.decay = Math.random() * 0.02 + 0.015;
        // Color azul #2563eb
        this.r = 37;
        this.g = 99;
        this.b = 235;
      }

      update() {
        // Expandir como acuarela más gradual
        if (this.radius < this.maxRadius) {
          this.radius += 0.35;
        }

        // Movimiento más suave y fluido
        this.x += this.vx;
        this.y += this.vy;
        this.vx *= 0.97;
        this.vy *= 0.97;

        // Desvanecer suavemente
        this.life -= this.decay;
        this.opacity = this.life * 0.35;
      }

      draw(ctx) {
        ctx.save();

        // Crear gradiente radial para efecto de acuarela
        const gradient = ctx.createRadialGradient(
          this.x,
          this.y,
          0,
          this.x,
          this.y,
          this.radius,
        );

        gradient.addColorStop(
          0,
          `rgba(${this.r}, ${this.g}, ${this.b}, ${this.opacity})`,
        );
        gradient.addColorStop(
          0.3,
          `rgba(${this.r}, ${this.g}, ${this.b}, ${this.opacity * 0.4})`,
        );
        gradient.addColorStop(1, `rgba(${this.r}, ${this.g}, ${this.b}, 0)`);

        ctx.globalCompositeOperation = "screen";
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fill();

        ctx.restore();
      }

      isDead() {
        return this.life <= 0;
      }
    }

    // Mouse tracking
    let mouseX = 0;
    let mouseY = 0;
    let lastX = 0;
    let lastY = 0;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      // Crear partículas solo si hay movimiento
      const dx = mouseX - lastX;
      const dy = mouseY - lastY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance > 1.5) {
        // Más partículas para efecto fluido continuo
        const particleCount = Math.min(Math.ceil(distance / 10), 3);
        for (let i = 0; i < particleCount; i++) {
          particles.push(
            new WatercolorParticle(
              mouseX + (Math.random() - 0.5) * 6,
              mouseY + (Math.random() - 0.5) * 6,
            ),
          );
        }
      }

      lastX = mouseX;
      lastY = mouseY;
    };

    // Animación
    const animate = () => {
      // Limpiar completamente el canvas para fondo transparente
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Actualizar y dibujar partículas
      particles = particles.filter((particle) => {
        particle.update();
        particle.draw(ctx);
        return !particle.isDead();
      });

      // Limitar número de partículas para performance
      if (particles.length > 150) {
        particles = particles.slice(-150);
      }

      animationId = requestAnimationFrame(animate);
    };

    // Event listeners
    window.addEventListener("mousemove", handleMouseMove);
    animate();

    // Cleanup
    return () => {
      window.removeEventListener("resize", resizeCanvas);
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 z-[9999] pointer-events-none w-full h-full">
      <canvas
        ref={canvasRef}
        className="w-full h-full block"
        style={{ background: "transparent" }}
      />
    </div>
  );
}

export default SplashCursor;
